<template>
  <div style="padding: 20px;overflow: auto" v-loading="isLoading">
    <ul class="List-headr">
      <li>
        <el-date-picker v-model="time" size="small" value-format="yyyyMMdd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false" :picker-options="expireTimeOption" @change="getData"></el-date-picker>
      </li>
      <li>
        <el-radio-group v-model="adStatisType" size="small" @change="setAdStatisType">
          <el-radio-button :label="1">广告主</el-radio-button>
          <el-radio-button :label="2">代码位类型</el-radio-button>
          <el-radio-button :label="3">创意类型</el-radio-button>
        </el-radio-group>
      </li>
      <li>
        <el-select v-if="adStatisType === 1" v-model="advertiserId" size="small" placeholder="请选择" filterable @change="getData">
          <el-option v-for="item in advertiserIdData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-if="adStatisType === 2" v-model="slotType" size="small" placeholder="请选择" filterable @change="getData">
          <el-option v-for="item in slotTypeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-if="adStatisType === 3" v-model="ideaTypeId" size="small" placeholder="请选择" filterable @change="getData">
          <el-option v-for="item in ideaTypeIdData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </li>
    </ul>
    <div class="house_chart">
      <div id="myChart" :style="{width: '100%', height: '400px'}"></div>
      <ul>
        <li v-for="(item, index) of lineData" :key="index" :class="[lineIndex.indexOf(item.id) > -1 ? 'c118DEE' : '']" @click="setLine(item)">{{item.name}}</li>
      </ul>
    </div>
    <div>
      <ul class="List-headr">
        <li>
          <el-radio-group size="small" v-model="createDayFlag" @change="getData">
            <el-radio-button label="">时间段</el-radio-button>
            <el-radio-button label="1">日</el-radio-button>
          </el-radio-group>
        </li>
        <li style="float: right">
          <el-button type="primary" size="small" @click="setExport">导出</el-button>
        </li>
      </ul>
      <el-table :data="tableData">
        <el-table-column v-if="this.adStatisType === 1" prop="advertiserName" label="广告主" width="200" key="1"></el-table-column>
        <el-table-column v-else-if="this.adStatisType === 2" prop="slotType" label="代码位类型" width="150" key="2"></el-table-column>
        <el-table-column v-else-if="this.adStatisType === 3" prop="ideaTypeName" label="创意类型" width="150" key="3"></el-table-column>
        <el-table-column prop="createDay" label="日期" width="150" key="4"></el-table-column>
        <el-table-column prop="bidNum" label="竞价参与量" width="150" key="5"></el-table-column>
        <el-table-column prop="bidSuccessNum" label="竞价成功量" width="150" key="6"></el-table-column>
        <el-table-column prop="bidSuccessRatio" label="竞价成功率(%)" width="150" key="7"></el-table-column>
        <el-table-column prop="showNum" label="展现量" width="150" key="8"></el-table-column>
        <el-table-column prop="clickNum" label="点击量" width="150" key="9"></el-table-column>
        <el-table-column prop="clickRatio" label="点击率(%)" width="150" key="10"></el-table-column>
        <el-table-column prop="income" label="收入" width="150" key="11"></el-table-column>
        <el-table-column prop="cpc" label="CPC" width="150" key="12"></el-table-column>
        <el-table-column prop="cpm" label="CPM" width="150" key="13"></el-table-column>
        <el-table-column prop="activateNum" label="转化量" width="150" key="14"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'finance',
  data () {
    return {
      isLoading: false,
      time: [this.myOption.getDate(6), this.myOption.getDate(0)],
      chartData: [],
      lineData: [
        {id: 'income', name: '收入'},
        {id: 'showNum', name: '展现量'},
        {id: 'clickNum', name: '点击量'},
        {id: 'clickRatio', name: '点击率(%)'},
        {id: 'cpm', name: 'CPM'},
        {id: 'cpc', name: 'CPC'},
        {id: 'activateNum', name: '转化量'}
      ],
      lineIndex: ['income'],
      tableData: [],
      adStatisType: 1,
      advertiserId: '',
      advertiserIdData: this.myOption.selectwhole,
      slotType: '',
      slotTypeData: [...this.myOption.selectwhole, ...this.myOption.slotType],
      ideaTypeId: '',
      ideaTypeIdData: this.myOption.selectwhole,
      createDayFlag: '',
      expireTimeOption: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    this.getData()
    this.getAdvertiser()
    this.getIdeatype()
  },
  methods: {
    // 获取数据
    getData () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.myOption.requestModule.chart.children.advert.id
        },
        url: this.myOption.requestUrl + this.myOption.requestModule.chart.children.advert.api,
        data: this.qs.stringify({
          createDayFlag: this.createDayFlag,
          adStatisType: this.adStatisType,
          advertiserId: this.advertiserId,
          slotType: this.slotType,
          ideaTypeId: this.ideaTypeId,
          startDay: this.time[0],
          endDay: this.time[1]
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.chartData = res.data.data.visionListVo
          if (this.adStatisType === 2) {
            for (let val of res.data.data.detailListVo) {
              val.slotType = this.myOption.getIdData('slotType', val.slotType * 1, 'name')
            }
          }
          this.tableData = res.data.data.detailListVo
          this.drawLine()
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取广告主
    getAdvertiser () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.myOption.requestModule.chart.children.advert.id
        },
        url: this.myOption.requestUrl + this.myOption.requestModule.chart.children.advert.adowner,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let arr = []
          for (let val of res.data.data.data) {
            arr.push({id: val.advertiserId, name: val.advertiserName})
          }
          this.advertiserIdData = [...this.myOption.selectwhole, ...arr]
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 获取创意类型
    getIdeatype () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.myOption.requestModule.chart.children.advert.id
        },
        url: this.myOption.requestUrl + this.myOption.requestModule.chart.children.advert.ideatype,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let arr = []
          for (let val of res.data.data.data) {
            arr.push({id: val.ideaTypeId, name: val.ideaTypeName})
          }
          this.ideaTypeIdData = [...this.myOption.selectwhole, ...arr]
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 渲染趋势图
    drawLine () {
      this.isLoading = true
      // 根据趋势图类型选项处理数据
      let xData = []
      let xState = true
      let yData = []
      for (let val of this.chartData) {
        let lineData = []
        for (let val2 of val) {
          if (xState) {
            xData.push(this.myOption.getTimeStampDate(val2.createDay))
          }
          lineData.push(val2[this.lineIndex[0]])
        }
        xState = false
        yData.push({
          name: this.adStatisType === 2 ? this.myOption.getIdData('slotType', val[0].slotType * 1, 'name') : val[0][this.adStatisType === 1 ? 'advertiserName' : this.adStatisType === 3 ? 'ideaTypeName' : ''],
          data: lineData,
          type: 'line',
          symbol: 'circle',
          symbolSize: 6,
          showSymbol: true,
          smooth: true,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1,
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 6
          }
        })
      }
      // 基于准备好的dom，初始化echarts实例
      if (!this.doc_chart) {
        this.doc_chart = this.$echarts.init(document.getElementById('myChart'))
      }
      // 绘制图表
      this.doc_chart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,.9)',
          borderColor: '#333',
          borderWidth: 1,
          padding: [10, 20],
          textStyle: {
            color: '#000',
            fontSize: 12
          },
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
              backgroundColor: '#447ed9',
              margin: 5
            },
            shadowStyle: {
              color: 'rgba(33,155,237,.1)'
            }
          }
        },
        grid: {
          bottom: '12%'
        },
        legend: {
          show: false,
          data: '',
          bottom: 0
        },
        xAxis: {
          data: xData,
          type: 'category',
          lineWidth: 0,
          boundaryGap: true,
          silent: true,
          axisLine: {
            lineStyle: {
              color: '#888'
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: '#333'
          }
        },
        yAxis: {
          axisLine: {
            show: true
          },
          axisLabel: {
            color: '#333'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          type: 'value',
          splitNumber: 5,
          minInterval: 1
        },
        series: yData
      }, true)
      this.isLoading = false
    },
    setLine (data) {
      if (this.lineIndex.indexOf(data.id) > -1) {
        return false
      }
      this.lineIndex.splice(0, 1)
      this.lineIndex.push(data.id)
      this.drawLine()
    },
    // 导出
    setExport () {
      this.$axios({
        method: 'post',
        responseType: 'arraybuffer',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.myOption.requestModule.chart.children.finance.id
        },
        url: this.myOption.requestUrl + this.myOption.requestModule.chart.children.finance.export,
        data: this.qs.stringify({
          createDayFlag: this.createDayFlag,
          advertiserId: this.advertiser,
          startDay: this.time[0],
          endDay: this.time[1]
        })
      }).then(res => {
        var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        var objectUrl = URL.createObjectURL(blob)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = objectUrl
        a.download = '广告统计'
        a.click()
        document.body.removeChild(a)
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    setAdStatisType () {
      this.advertiserId = ''
      this.slotType = ''
      this.ideaTypeId = ''
      this.getData()
    }
  }
}
</script>

<style scoped>
  .house_header{
    margin-bottom: 20px;
    padding: 20px;
    width: 100%;
    border: 1px solid #ccc;
    height: 150px;
  }
  .house_header>ul{
    display: flex;
    justify-content: space-between;
    height: 100%;
  }
  .house_header>ul>li{
    margin-left: 20px;
    padding: 20px 20px 20px 0;
    width: 20%;
    height: 100%;
    border-right: 1px solid #ccc;
  }
  .house_header>ul>li>p:first-child{
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .house_header>ul>li>p:last-child{
    color: #666;
    font-size: 18px;
  }
  .house_header>ul>li:first-child{
    margin-left: 0;
  }
  .house_header>ul>li:last-child{
    border-right: 0;
  }

  .house_chart{
    margin-bottom: 20px;
    width: 100%;
    border: 1px solid #ccc;
    padding: 20px
  }
  .house_chart>ul{
    display: flex;
    justify-content: center;
  }
  .house_chart>ul>li{
    position: relative;
    margin: 0 30px;
    font-size: 14px;
    cursor: pointer;
  }
  .house_chart>ul>li:before{
    content: ' ';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-120%, -50%);
    width: 10px;
    height: 2px;
  }
  .house_chart>ul>li:after{
    content: ' ';
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(120%, -50%);
    width: 10px;
    height: 2px;
  }

  .c118DEE{
    color: #118DEE;
  }
  .c118DEE:before, .c118DEE:after{
    background-color: #118DEE;
  }
  .c5EB432{
    color: #5EB432;
  }
  .c5EB432:before, .c5EB432:after{
    background-color: #5EB432;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/advert.vue